export default { sha: '6310afac1345e02c21258037dbb15254dfe1cd8e', buildNumber: 'undefined' }
